import { createContext, useContext, useEffect, useState } from 'react';
import translations from '../../data/translations';

const LanguageContext = createContext();
const STORAGE_KEY = 'savia-lang';

const initialLang = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === 'en' || saved === 'es' ? saved : 'es';
  } catch {
    return 'es';
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);
  const toggleLang = () => setLang((prev) => (prev === 'es' ? 'en' : 'es'));

  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // Sin almacenamiento disponible (ventana privada, etc.): el idioma igual funciona.
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
